// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__xeWXX","boxBtn":"Auth_boxBtn__NLb7r"};